var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:`btn btn-${_vm.variant} ${_vm.customClass}`,attrs:{"href":"#","disabled":_vm.isDisabled},on:{"click":_vm.executeEvent}},[_vm._v("\n  "+_vm._s(_vm.isDisabled ? "Loading.." : _vm.content)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }